import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAlerts = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={22}
    height={22}
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      d="M3.616 14.35a.779.779 0 0 1 1.557 0v4.671a.779.779 0 0 1-1.557 0zM3.616 5.8c0-.838.543-1.58 1.343-1.835a6.74 6.74 0 0 1 4.782.266l.846.376a7.08 7.08 0 0 0 4.576.405 2.022 2.022 0 0 1 2.508 1.963v3.592c0 1.281-.954 2.361-2.226 2.518l-.501.062a7.2 7.2 0 0 1-4.07-.69l-.77-.382a5.3 5.3 0 0 0-4.39-.14 1.515 1.515 0 0 1-2.098-1.398z"
    />
  </svg>
);
export default SvgAlerts;
